import request from '@/utils/request'
import axios from 'axios'
import { developHost } from '@/constant'

// Mock数据
const mockData = {
  loginByUsername: {
    success: {
      code: 200,
      msg: "success",
      data: {
        token: "mock_token_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9)
      }
    },
    error: {
      code: 401,
      msg: "用户名或密码错误",
      data: null
    }
  },
  getUserInfo: {
    code: 200,
    data: {
      code: 200,
      data: {
        roleList: ["上传者", "审核者"],
        user: {
          isLock: "N",
          centerId: 6,
          gmtModified: "2019-12-18 18:10:19",
          titleId: 6,
          name: "GIMC-admin",
          pirateUserId: null,
          avatar: "",
          id: 2,
          gmtCreate: null,
          email: "15622189056@163.com",
          gmUserThirdAccountRelateList: [
            {
              platformType: "WX",
              platformUserId: "wx_123456",
              nickname: "微信用户"
            }
          ]
        },
        privilegeList: [
          // 基础权限
          {
            accessId: 1,
            accessValue: "admin",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 1,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "管理员"
          },
          {
            accessId: 2,
            accessValue: "personalBoard",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 2,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "个人看板"
          },
          // 推广模块权限
          {
            accessId: 3,
            accessValue: "adManager",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 3,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "广告管理"
          },
          {
            accessId: 4,
            accessValue: "materialManager",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 4,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "素材管理"
          },
          {
            accessId: 5,
            accessValue: "creativeManager",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 5,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "创意管理"
          },
          // 报表模块权限
          {
            accessId: 6,
            accessValue: "accountReport",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 6,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "账户报表"
          },
          {
            accessId: 7,
            accessValue: "campaignReport",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 7,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "广告组报表"
          },
          {
            accessId: 8,
            accessValue: "adReport",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 8,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "广告计划报表"
          },
          {
            accessId: 9,
            accessValue: "creativeReport",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 9,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "广告创意报表"
          },
          {
            accessId: 10,
            accessValue: "modelReport",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 10,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "车型报表"
          },
          {
            accessId: 11,
            accessValue: "summary",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 11,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "汇总报表"
          },
          {
            accessId: 12,
            accessValue: "audienceReport",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 12,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "受众报表"
          },
          {
            accessId: 13,
            accessValue: "tagStat",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 13,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "标签统计"
          },
          {
            accessId: 14,
            accessValue: "LibDemandMaterial",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 14,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "素材数据报表"
          },
          // 二网素材库权限
          {
            accessId: 15,
            accessValue: "secondWebVideo",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 15,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "二网视频库"
          },
          // 设置模块权限
          {
            accessId: 16,
            accessValue: "materialTagSetting",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 16,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "标签管理"
          },
          {
            accessId: 17,
            accessValue: "modelManager",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 17,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "车型管理"
          },
          {
            accessId: 18,
            accessValue: "adr",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 18,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "账户管理"
          },
          // 安全模块权限
          {
            accessId: 19,
            accessValue: "authorize",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 19,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "授权管理"
          },
          {
            accessId: 20,
            accessValue: "permission",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 20,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "权限管理"
          },
          {
            accessId: 21,
            accessValue: "log",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 21,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "操作日志"
          },
          // 线索转发权限
          {
            accessId: 22,
            accessValue: "transformNissan",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 22,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "日产线索转发"
          },
          {
            accessId: 23,
            accessValue: "transformVw",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 23,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "大众线索转发"
          },
          {
            accessId: 24,
            accessValue: "transformBuick",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 24,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "别克线索转发"
          },
          {
            accessId: 25,
            accessValue: "transformCadillac",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 25,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "凯迪拉克线索转发"
          },
          {
            accessId: 26,
            accessValue: "transformChevrolet",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 26,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "雪佛兰线索转发"
          },
          {
            accessId: 27,
            accessValue: "transformConsumer",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 27,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "通用获客中心"
          },
          // 缺失的权限
          {
            accessId: 28,
            accessValue: "campaignManage",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 28,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "广告组管理"
          },
          {
            accessId: 29,
            accessValue: "accAudience",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 29,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "账户受众"
          },
          {
            accessId: 30,
            accessValue: "campaignAudience",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 30,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "广告组受众"
          },
          {
            accessId: 31,
            accessValue: "adAudience",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 31,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "广告计划受众"
          },
          {
            accessId: 32,
            accessValue: "creativeAudience",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 32,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "广告创意受众"
          },
          {
            accessId: 33,
            accessValue: "proCreative",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 33,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "产品创意报表"
          },
          {
            accessId: 34,
            accessValue: "materialStat",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 34,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "素材统计"
          },
          {
            accessId: 35,
            accessValue: "transformSvw",
            gmtModified: null,
            access: "Menu",
            isOperation: "",
            modelId: 1,
            id: 35,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "SVW线索转发"
          },
          // 按钮权限
          {
            accessId: 36,
            accessValue: "create_campaign",
            gmtModified: null,
            access: "Button",
            isOperation: "",
            modelId: 1,
            id: 36,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "创建广告"
          },
          {
            accessId: 37,
            accessValue: "edit_campaign",
            gmtModified: null,
            access: "Button",
            isOperation: "",
            modelId: 1,
            id: 37,
            gmtCreate: null,
            masterValue: "2",
            url: "",
            master: "User",
            privilegeName: "编辑广告"
          }
        ]
      },
      message: "success"
    },
    msg: "success"
  },
  wxLoginUrl: {
    code: 200,
    msg: "success",
    data: {
      uuid: "mock_uuid_" + Date.now(),
      webUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg=="
    }
  },
  wxLoginRequest: {
    success: {
      code: 200,
      msg: "success",
      data: "mock_wx_token_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9)
    },
    error: {
      code: 400,
      msg: "二维码已过期或未扫码",
      data: null
    }
  }
}

// 判断是否使用mock数据
const useMock = process.env.NODE_ENV === 'development'

export function loginByUsername(userInfo) {
  const data = {
    account: userInfo.account,
    password: userInfo.password
  }
  
  if (useMock) {
    // 使用mock数据
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        // 模拟用户名密码验证
        if ((userInfo.account === 'admin' || userInfo.account === 'test') && userInfo.password === 'e10adc3949ba59abbe56e057f20f883e') {
          resolve(mockData.loginByUsername.success)
        } else {
          reject(mockData.loginByUsername.error)
        }
      }, 500) // 模拟网络延迟
    })
  }
  
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

export function logout() {
  if (useMock) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          code: 200,
          msg: "success",
          data: null
        })
      }, 300)
    })
  }
  
  return request({
    url: '/login/logout',
    method: 'post'
  })
}

export function getUserInfo() {
  if (useMock) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(mockData.getUserInfo)
      }, 800)
    })
  }
  
  return request({
    url: '/userInfo',
    method: 'get',
    retry: 3, // 减少重试次数，避免过多请求
    retryDelay: 2000, // 增加重试间隔时间
    timeout: 10000 // 设置较短的超时时间
  })
}

const accessId = 1
const redirectUri = process.env.NODE_ENV === 'production' ? `http://daworker.gimc-auto.com/wxauth/index.html` : `http://dev.gimc-auto.com/wxauth/index.html`
// const redirectUri =`http://dev.gimc-auto.com/wxauth/index.html`
const authUrl = `${redirectUri}#/authorization` //授权重定向
const loginUrl = `${redirectUri}#/loginMessage` //登录重定向

// 获取wx授权页面
export function getWxBindUrl() {
  if (useMock) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          code: 200,
          msg: "success",
          data: {
            authUrl: "https://mock-wechat-auth.com/auth?redirect=" + encodeURIComponent(authUrl)
          }
        })
      }, 300)
    })
  }
  
  return request({
    url: '/wx-authorize-url',
    method: 'get',
    params: {
      accessId, redirectUri: authUrl
    }
  })
}

// 获取wx登录授权页面url
export function getWxLoginUrl() {
  if (useMock) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(mockData.wxLoginUrl)
      }, 300)
    })
  }
  
  return request({
    url: '/wx-login-authorize-url',
    method: 'get',
    params: {
      accessId, redirectUri: loginUrl
    }
  })
}

// 授权登录请求
export function getWxLoginRequest(params) {
  if (useMock) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        // 模拟微信扫码登录状态检查
        const mockStatus = Math.random() > 0.5 // 50%概率成功
        if (mockStatus) {
          resolve(mockData.wxLoginRequest.success)
        } else {
          reject(mockData.wxLoginRequest.error)
        }
      }, 1000)
    })
  }
  
  return request({
    url: '/wx-login-authorize',
    method: 'get',
    params
  })
}

// 用户解绑微信
export function unBindWx(params) {
  if (useMock) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          code: 200,
          msg: "success",
          data: null
        })
      }, 300)
    })
  }
  
  return request({
    url: '/unbinding-wx-user',
    method: 'get',
    params
  })
}

// 绑定微信结果查询
export function queryWxBind(params) {
  if (useMock) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          code: 200,
          msg: "success",
          data: {
            isBind: true,
            platformType: "WX",
            nickname: "微信用户"
          }
        })
      }, 300)
    })
  }
  
  return request({
    url: '/wx-binding-result-query',
    method: 'get',
    params
  })
}